"use client";
import { RouteError } from "@/components/ui/ErrorState";
export default function Error(props: { error: Error & { digest?: string }; reset: () => void }) {
  return <RouteError {...props} />;
}
